import React from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'

class ConfirmDialog extends React.Component {
  render() {
    const { open, title, content, onOK, onClose } = this.props
    return (
      <Dialog open={open} onClose={onClose}>
        {title && (
          <DialogTitle>{title}</DialogTitle>
        )}
        {content && (
          <DialogContent>{content}</DialogContent>
        )}
        <DialogActions>
          <Button onClick={onOK} color='primary'>OK</Button>
          <Button onClick={onClose} color='primary'>Cancel</Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default ConfirmDialog


// WEBPACK FOOTER //
// ./src/components/Common/ConfirmDialog.js